import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private storage: Storage

  constructor() {
    this.storage = window.localStorage
  }

  setItem(key: string, value: any): boolean {
    if (this.storage) {
      this.storage.setItem(key, JSON.stringify(value))
      return true
    }
    return false
  }

  getItem(key: string): any {
    if (this.storage) {
      var storageResult =
        storageResult !== null ? this.storage.getItem(key) : null
      return JSON.parse(storageResult)
    }
    return null
  }

  SetStyleVar(name: string, value: string) {
    document.documentElement.style.setProperty(name, value)
  }
}
